import { request } from "./client.js";
import { E } from "./endpoints.js";
import type { SubscriptionListResponse } from "../types/subscription.js";
import { subscriptionListResponseSchema } from "../schemas/subscription.js";

/** GET /v1/lk/subscriptions */
export async function listSubscriptions(): Promise<SubscriptionListResponse> {
  return request(E.lk.subscriptions, {}, subscriptionListResponseSchema);
}
